import LegalLayout, { Section } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Regulamin serwisu" lastUpdated="28 maja 2026">
      <p className="text-base">
        Niniejszy regulamin określa zasady korzystania z serwisu internetowego telecombts.pl
        prowadzonego przez Telecom BTS sp. z o.o. Korzystanie z serwisu oznacza akceptację
        postanowień niniejszego regulaminu.
      </p>

      <Section title="1. Definicje">
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li><strong>Usługodawca</strong> — Telecom BTS sp. z o.o. z siedzibą w Warszawie, ul. Adama Mickiewicza 55, 01-625 Warszawa, NIP 525-28-44-929, KRS 0000872371, REGON 387672774, kapitał zakładowy 50 000 zł.</li>
          <li><strong>Serwis</strong> — strona internetowa dostępna pod adresem telecombts.pl.</li>
          <li><strong>Użytkownik</strong> — każda osoba korzystająca z serwisu.</li>
          <li><strong>Formularz</strong> — formularz kontaktowy dostępny w serwisie, służący zgłoszeniu zainteresowania dzierżawą nieruchomości pod maszt telekomunikacyjny.</li>
        </ul>
      </Section>

      <Section title="2. Zakres usług">
        <p>Za pośrednictwem serwisu Usługodawca świadczy następujące usługi nieodpłatnie:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>udostępnianie informacji o ofercie dzierżawy gruntów i dachów pod stacje bazowe BTS,</li>
          <li>umożliwienie kontaktu poprzez formularz zgłoszeniowy,</li>
          <li>bezpłatna wstępna ocena potencjału nieruchomości zgłoszonej przez Użytkownika.</li>
        </ul>
      </Section>

      <Section title="3. Wymagania techniczne">
        <p>Do prawidłowego korzystania z serwisu wymagane jest:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>urządzenie z dostępem do Internetu,</li>
          <li>przeglądarka internetowa w aktualnej wersji (Chrome, Firefox, Safari, Edge),</li>
          <li>włączona obsługa JavaScript oraz plików cookie (dla niektórych funkcji).</li>
        </ul>
      </Section>

      <Section title="4. Zasady korzystania z formularza">
        <p>
          Wysłanie formularza kontaktowego nie stanowi zawarcia umowy dzierżawy ani żadnej innej umowy.
          Stanowi wyłącznie zgłoszenie zainteresowania ofertą i prośbę o kontakt zwrotny w celu omówienia
          warunków potencjalnej współpracy.
        </p>
        <p>
          Użytkownik wypełniając formularz oświadcza, że podane dane są prawdziwe oraz że jest uprawniony
          do dysponowania zgłaszaną nieruchomością (jest jej właścicielem, współwłaścicielem lub posiada
          stosowne pełnomocnictwo).
        </p>
      </Section>

      <Section title="5. Czas reakcji">
        <p>
          Usługodawca zobowiązuje się do podjęcia próby kontaktu z Użytkownikiem w terminie do
          <strong> 24 godzin roboczych</strong> od momentu otrzymania prawidłowo wypełnionego formularza.
          Termin ten nie obejmuje dni wolnych od pracy.
        </p>
      </Section>

      <Section title="6. Odpowiedzialność">
        <p>
          Usługodawca dokłada starań, aby informacje publikowane w serwisie były aktualne i rzetelne,
          jednak nie ponosi odpowiedzialności za decyzje podjęte przez Użytkownika wyłącznie na podstawie
          treści dostępnych w serwisie. Konkretne warunki dzierżawy zawsze ustalane są indywidualnie po
          przeprowadzeniu bezpłatnego audytu lokalizacji.
        </p>
        <p>
          Serwis nie prezentuje konkretnych stawek czynszu. Wysokość czynszu ustalana jest indywidualnie
          i przedstawiana Użytkownikowi podczas spotkania, po bezpłatnym audycie lokalizacji. Konkretna
          kwota zależy od lokalizacji, dostępu komunikacyjnego, wysokości konstrukcji, zainteresowania
          operatorów i innych czynników.
        </p>
      </Section>

      <Section title="7. Reklamacje">
        <p>
          Wszelkie reklamacje dotyczące funkcjonowania serwisu należy zgłaszać na adres
          <a href="mailto:biuro@telecombts.pl" className="text-emerald-700 hover:underline ml-1">biuro@telecombts.pl</a>.
          Reklamacja powinna zawierać dane kontaktowe oraz opis problemu. Odpowiedź zostanie udzielona
          w terminie do 14 dni od jej otrzymania.
        </p>
      </Section>

      <Section title="8. Prawa autorskie">
        <p>
          Wszystkie treści zamieszczone w serwisie (teksty, grafiki, układ strony) są przedmiotem ochrony
          prawnoautorskiej. Kopiowanie, modyfikowanie lub wykorzystywanie ich w jakikolwiek sposób bez
          pisemnej zgody Usługodawcy jest zabronione.
        </p>
        <p>
          Znaki towarowe operatorów telekomunikacyjnych prezentowane w serwisie należą do ich
          właścicieli i są wykorzystywane wyłącznie w celach informacyjnych.
        </p>
      </Section>

      <Section title="9. Postanowienia końcowe">
        <p>
          W sprawach nieuregulowanych regulaminem zastosowanie mają przepisy prawa polskiego,
          w szczególności Kodeksu cywilnego oraz ustawy o świadczeniu usług drogą elektroniczną.
        </p>
        <p>
          Usługodawca zastrzega prawo do zmiany regulaminu. Aktualna wersja jest zawsze dostępna
          w serwisie wraz z datą ostatniej aktualizacji.
        </p>
      </Section>
    </LegalLayout>
  );
}
